// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2073":"a7e6022cf6d56997","3537":"ef3cb56570e0eeaa","5492":"c58a9747472a3a25","6186":"8999b25504cf5da7"}[chunkId] + ".js";
};